import { number, shape, string } from 'prop-types'
import styles from './EventSponsorStrip.module.scss'
import React from 'react'
import Type from '@/component/Primitive/Type'
import Container from '@/component/Primitive/Container'

export const EventSponsorStrip = ({ preText, sponsors }) => (
  <div className={styles.EventSponsorStrip}>
    <Container size="large" center gutter>
      <dl className={styles.EventSponsorStripDl}>
        <Type as="dt" size="body3">
          {preText || 'In association with:'}
        </Type>

        {sponsors.map((sponsor, index) => (
          <dd key={index}>
            {sponsor.logoSponsorUrl ? (
              <img
                className={
                  sponsor.logoSponsorSize === 'large'
                    ? styles.EventSponsorStripImageLarge
                    : null
                }
                src={sponsor.logoSponsorUrl}
                alt={sponsor.displayName}
              />
            ) : (
              <Type as="span" size="body-2">
                {sponsor.displayName}
              </Type>
            )}
          </dd>
        ))}
      </dl>
    </Container>
  </div>
)

export const SponsorsShape = shape({
  id: string,
  displayName: string,
  orderIndex: number,
  logoSponsorUrl: string,
  tier: shape({
    name: string
  })
})

EventSponsorStrip.propTypes = {
  preText: string,
  sponsors: SponsorsShape
}
